<template>
  <div class="system-dic-dialog-container">
    <el-dialog :title="title" :visible.sync="isShowDialog" width="550px">
      <el-form
        ref="dicDialogFormRef"
        :model="formData"
        v-loading="isLoading"
        :rules="rules"
        size="small"
        label-width="90px"
        class="demo-ruleForm"
      >
        <el-row :gutter="35">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="问题" prop="Question">
              <el-input
                v-model="formData.Question"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="答案" prop="Answer">
              <el-input
                v-model="formData.Answer"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="onCancel" size="default">取 消</el-button>
          <el-button
            :loading="btnLoading"
            type="primary"
            @click="onSubmit"
            size="default"
            >保存</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { addFaqs, putFaqs } from "@/api/appealManage/appealManage";

export default {
  props: {
    Type: String,
  },
  data() {
    return {
      editor: null,
      key: "edit",
      title: "编辑",
      isShowDialog: false,
      isLoading: false,
      btnLoading: false,
      formData: {},
      rules: {
        Question: [{ required: true, message: "请输入问题", trigger: "blur" }],
        Answer: [{ required: true, message: "请输入答案", trigger: "blur" }],
      },
    };
  },
  computed: {
    getUrlList() {
      return function (urls) {
        if (!urls) return [];
        return urls.split(",");
      };
    },
  },
  methods: {
    gotoPreview() {
      let routeUrl = this.$router.resolve({
        path: "/preview",
        // query: { url: this.formData.FromData },
        query: { url: this.formData.FromData },
      });
      window.open(routeUrl.href, "_blank");
    },
    openDialog(e, key) {
      this.formData = e;
      this.key = key;
      this.resetForm("");
      let dic = {
        edit: "编辑",
        add: "新增",
        preview: "预览",
      };
      this.title = dic[key];
      this.isShowDialog = true;
    },
    resetForm(formName) {
      this.$refs.dicDialogFormRef && this.$refs.dicDialogFormRef.resetFields();
    },
    onCancel() {
      this.isShowDialog = false;
    },
    handleAvatarSuccess(res, file) {
      this.formData.Picture = res.response.Url;
    },
    onSubmit() {
      this.btnLoading = true;
      let that = this;
      this.$refs.dicDialogFormRef.validate((valid) => {
        this.btnLoading = false;
        if (valid) {
          that.submit();
        } else {
          console.log("error submit!!", valid);
          return false;
        }
      });
    },
    submit() {
      let param = {
        ...this.formData,
      };
      param.State = 1;
      if (param.Id) {
        this.HttpUpdateBlogDetail(param);
      } else {
        this.HttpAddBlogDetail(param);
      }
    },
    async HttpUpdateBlogDetail(param) {
      this.btnLoading = true;
      const response = await putFaqs(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpAddBlogDetail(param) {
      this.btnLoading = true;
      const response = await addFaqs(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>
<style>
.center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.idcard {
  width: 258px;
  height: 162px;
  border: 1px solid #e4e7ed;
  background: #f4f5f7;
  border-radius: 4px;
}
</style>
